// Identify notes by their position in the original pitch sequence. Omissions do
// not change string boundaries, fret normalization or the positions of other notes.
export const omitChartNotes = (chartData, omittedNotes = []) => {
  const omitted = new Set(omittedNotes);
  let id = 0;
  const noteIds = [];
  const visible = chartData.map(string => {
    const ids = [];
    const notes = string.filter(() => {
      const current = id++;
      if (omitted.has(current)) return false;
      ids.push(current);
      return true;
    });
    noteIds.push(ids);
    return notes;
  });
  return { chartData: visible, noteIds };
};
